export const generativeCreativeField = Object.freeze({
  headlines: 'headlines',
  bodies: 'bodies',
  description: 'description',
})
